import type { CSSProperties, FC, ReactNode } from 'react'

// Wraps exactly one database text value so it can be edited inline from the preview.
// The attribute is `<table>:<row id>:<column>`, always the real column name.

type CmsTable = 'facilities' | 'racks' | 'devices'

interface CmsTextProps {
    table: CmsTable
    id: string
    field: string
    value: string | null | undefined
    as?: 'span' | 'p' | 'h1' | 'h2' | 'h3' | 'div' | 'dd'
    className?: string
    style?: CSSProperties
    title?: string
}

const CmsText: FC<CmsTextProps> = ({ table, id, field, value, as: Tag = 'span', className, style, title }): ReactNode => {
    return (
        <Tag data-mdlfy-cms={`${table}:${id}:${field}`} className={className} style={style} title={title}>
            {value ?? ''}
        </Tag>
    )
}

export default CmsText
